// extracted by mini-css-extract-plugin
export default {"emailRow":"SrmReportFastPay_emailRow_Waq_t"};